import { render, staticRenderFns } from "./SrIcon.vue?vue&type=template&id=e6aae094"
import script from "./SrIcon.vue?vue&type=script&lang=js"
export * from "./SrIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports